export const view02ImageOptions = {
  angle: 'view02',
  staticOptions: {
    BiminiColor: 1,
    GrabRails: 1,
    BowOption: 1,
    UpholsteryCockpit: 1,
    Engine: 1,
    AnchorStern: 1,
    AnchorBow: 1,
    Galley: 1
  },
  mattes: [
    {
      option: 'BiminiColor',
      dependency: 'TTop'
    },
    {
      option: 'BowOption',
      dependency: 'UpholsteryCockpit'
    },
    {
      option: 'UpholsteryCockpit',
      dependency: 'TTop'
    },
    {
      option: 'Engine',
      dependency: null
    },
    {
      option: 'AnchorBow',
      dependency: 'HullColour'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xpower/views/view02.js